import React, { useEffect, useState } from 'react';
import { Modal, Button, ANTD_COMPONENTS } from 'tt-ui-lib/core';
import styles from './ResultSelectionModal.module.scss';
import { CALC_PAGE_TYPES, CALC_TYPES } from 'utils/calculatorUtils';
import { getResults } from 'api/calc/endpoints/calc';

const getTotal = (val) =>
  Intl.NumberFormat('en-US', {
    notation: 'compact',
    maximumFractionDigits: 1,
    style: 'unit',
    unit: 'kilogram',
  }).format(val);

const options = [
  {
    id: 'none',
    name: "Don't use calculator results",
  },
];

const { Radio, Row, Col } = ANTD_COMPONENTS;

const ResultSelectionModal = (props) => {
  const { open, companyId, onClose, onFinish, onStartNew } = props;
  const [selectedResultId, setSelectedResultId] = useState(null);
  const [assessments, setAssessments] = useState([]);
  const [loading, setLoading] = useState(true);

  const getResultList = () => {
    getResults({ type: CALC_TYPES.CARBON, company_id: companyId })
      .then((resp) => {
        const { data, success } = resp?.data ?? {};
        if (success) setAssessments(data);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    getResultList();
  }, [companyId]);

  return (
    <Modal
      open={open}
      onClose={() => onClose(true)}
      onClick={(e) => e.stopPropagation()}
      title="Select calculator results"
    >
      <div className={styles.modalContainer}>
        <div>
          <p>You may select the calculator results you used to create your report.</p>
          <p>Or start a new self-assessment</p>
        </div>
        <div className={styles.resultBlock}>
          <Radio.Group
            onChange={(e) => setSelectedResultId(e.target.value)}
            value={selectedResultId}
            style={{ width: '100%', border: 'none' }}
            className={styles.radioGroup}
          >
            {[...options, ...assessments].map((option) => (
              <Radio
                key={option.id}
                value={option.id}
                className={styles.radioItem}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '8px 0',
                }}
              >
                <Row className={styles.radioItemBlock}>
                  <Col span={16}>{option.name}</Col>
                  <Col span={8}>{option.result && `${getTotal(option.result)} CO2`}</Col>
                </Row>
              </Radio>
            ))}
          </Radio.Group>
        </div>
        <div className={styles.buttonBlock}>
          <Button type="default" onClick={onStartNew}>
            Start new self-assessment
          </Button>
          <Button
            type="primary"
            onClick={() => onFinish(selectedResultId)}
            disabled={!selectedResultId}
          >
            Next
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ResultSelectionModal;
